class ResponsiveHelper {
    isDesktop = () => window.innerWidth >= 1378

    isTablet = () => window.innerWidth < 1378 && window.innerWidth > 768

    isMobile = () => window.innerWidth < 768
}

export default new ResponsiveHelper()